import React from "react";
import { TextField as MuiTextField } from "@mui/material";

interface TextFieldProps {
  label: string;
  value: string;
  type?: React.HTMLInputTypeAttribute;
  disabled?: boolean;
  onChange: (val: string) => void;
}

export default function MultilineTextField({
  label,
  value,
  type,
  disabled,
  onChange,
}: TextFieldProps) {
  return (
    <MuiTextField
      margin="dense"
      variant="filled"
      multiline
      minRows={4}
      label={label}
      type={type}
      value={value}
      disabled={disabled}
      onChange={(evt) => onChange(evt.target.value)}
    />
  );
}
